<template>
  <div>
    <content-heading2 icon="setting" title="ログインメールアドレスの確認" />
    <content-heading3 title="店舗検索" class="m-5" />
    <div class="container">
      <dialog-box :is-show="isShow" @input="isShow = false">
        <div class="dialog__header">
          <h4 class="title">店舗IDとは？</h4>
        </div>
        <hr class="solid" />
        <div>店舗IDはRettyに掲載されている店舗ページのURL末尾12桁の数字です。</div>
        <br />
        <div>例：店舗ページURLが以下の場合</div>
        <div>https://retty.me/area/PRE1/ARE10/SUB100/100000000000/</div>
        <div>店舗コードは「100000000000」となります。</div>
        <img :src="require(`@/mikan/_shared/images/preview.png`)" alt="" class="w-100" />
      </dialog-box>
      <div class="row form-input">
        <div class="form-input__label">
          <h4 class="title">店舗ID</h4>
          <a class="cursor-pointer" @click="isShow = true">店舗IDとは？</a>
        </div>

        <div class="form-input__input">
          <div class="row" style="height: 60px;">
            <input-text-validatable
              v-model="restaurantId.value"
              :error="restaurantId.error"
              :input-style="{
                height: '100%',
              }"
              class="row__child input__text"
            />
            <button-action
              :is-primary="true"
              class="button__action row__child"
              title="検索"
              @click="search"
            />
          </div>
          <p class="input-length my-2">（12文字）</p>
        </div>
      </div>
      <div class="dashed" />
      <div class="form-input row">
        <div class="form-input__label">
          <h4 class="title">連携しているメールアドレス</h4>
          <div>以下のメールアドレスが紐づいています</div>
        </div>
        <input-textarea
          :value="mails"
          :disabled="true"
          :rows="10"
          class="form-input__input"
        />
      </div>
      <div class="my-2">
        連携しているメールアドレスがご利用できない、 ご確認いただけない場合は<a :href="getEmailConfirmationGoogleFormUrl" target="_blank">こちら</a>より申請ください。
      </div>
      <loading-overlay v-show="isLoading" />
    </div>
  </div>
</template>
<script>
import ButtonAction from "@/mikan/_shared/components/atoms/ButtonAction.vue";
import InputTextarea from "@/mikan/_shared/components/atoms/InputTextarea.vue";
import LoadingOverlay from "@/mikan/_shared/components/molecules/LoadingOverlay.vue";
import InputTextValidatable from "@/mikan/_shared/components/molecules/InputTextValidatable.vue";
import DialogBox from "@/mikan/_shared/components/molecules/DialogBox.vue";
import ContentHeading2 from "@/mikan/_shared/components/atoms/ContentHeading2.vue";
import ContentHeading3 from "@/mikan/_shared/components/atoms/ContentHeading3.vue";
import { buildEmailConfirmationGoogleFormUrl } from '@/mikan/_shared/lib/urlBuilders';
import axios from "axios";

export default {
  components: {
    ButtonAction,
    InputTextarea,
    LoadingOverlay,
    InputTextValidatable,
    ContentHeading2,
    ContentHeading3,
    DialogBox,
  },
  data() {
    return {
      restaurantId: {
        value: "",
        error: "",
      },
      mailAdress: [],
      isLoading: false,
      isShow: false,
    };
  },
  computed: {
    mails() {
      return this.mailAdress.map(e => this.mailCensor(e)).join("\n\n");
    },
    getEmailConfirmationGoogleFormUrl() {
      return buildEmailConfirmationGoogleFormUrl();
    },
  },
  methods: {
    mailCensor(mail) {
      const head = mail.substr(0, mail.indexOf("@"));
      const encodedHead =
        head.length > 2
          ? head.replace(
              new RegExp(eval(`/(.{${head.length - 2}}$)/`)),
              "*".repeat(head.length - 2)
            )
          : "**";
      const tail = mail.substr(mail.indexOf("@") + 1);
      const encodedTail = tail.replace(
        new RegExp(eval(`/(.{${tail.length - 1}}$)/`)),
        "*".repeat(tail.length - 1)
      );
      return `${encodedHead}@${encodedTail}`;
    },
    async search() {
      if (
        this.restaurantId.value.toString().length != 12 ||
        isNaN(this.restaurantId.value)
      )
        return (this.restaurantId.error = "店舗IDは12文字で入力してください");
      this.isLoading = true;
      await axios
        .get(
          `mail-address-list?restaurantId=${this.restaurantId.value}`
        )
        .then(res => {
          this.mailAdress = res.data.data;
          this.restaurantId.error = res.data.message;
        });
      this.isLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/base/mixins';

.container {
  padding: 40px;
  margin: auto;
  background-color: $color-navy-05;
  color: $color-navy-50;
  @include for-sp {
    padding: 20px;
  }
}

.row {
  display: flex;
  height: 100%;
  align-items: baseline;
  gap: 12px;
  @include for-sp {
    gap: 32px;
  }

  &__child {
    height: 100%;
  }
}

.form-input {
  &__label {
    @include for-tb-pc {
      width: 24%;
    }

    text-align: start;
  }

  &__input {
    width: 100%;
    flex: auto;
  }
}

.w-100 {
  width: 100%;
}

.input__text {
  background-color: $color-navy-05;
}

.button__action {
  width: 180px;
}

.cursor-pointer {
  cursor: pointer;
}

.solid {
  border-top: 3px solid $color-navy-10;
}

.dashed {
  border-top: 1px dashed $color-navy-20;
  margin: 20px 0;
}

.dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .close {
    color: $color-black;
    font-size: medium;
    font-weight: 700;
  }
}

.title {
  font-size: 20px;
}

.my-2 {
  margin: 0.5rem 0;
}

.m-5 {
  margin: 1.25rem;
}

.input-length {
  font-size: $em-size-l;
  text-align: end;
}
</style>
